import React from 'react'
import homeIcon from '../../../assets/images/home-icon.png'
import backArrow from '../../../assets/images/back-arrow3.png'
import upArrow from '../../../assets/images/up-arrow.png'

const NavigationControls = ({ onHomeClick, onBackClick, onBackToTop }) => {
  return (
    <div className="go-back">
      <img
        className="nav-icon-home home"
        alt="Go to base of navigation"
        src={homeIcon}
        onClick={onHomeClick}
      />
      <img
        className="nav-icon-back back"
        alt="Go back one level."
        src={backArrow}
        onClick={onBackClick}
      />
      <img
        className="nav-icon-top top"
        alt="Go back to top."
        src={upArrow}
        onClick={onBackToTop}
      />
    </div>
  )
}

export default NavigationControls
